import { useTranslation } from "react-i18next";
import { useAppDispatch, useAppSelector } from "src/common/state/hooks";
import { useNavigate } from "react-router-dom";
import { FooterButtons } from "../../../common/components/FooterButtons";
import { closeStandardModal } from "../../../common/state/slice/modal/modalSlice";
import type { RootState } from "../../../common/state/store";
import type { IMedia } from "../../../model/unityObject";
import { getCurrentMediaGallery } from "../state/gallerySlice";

export const Actions = ({
  onConfirmSelectMedia,
  onCancel,
  modalId,
}: {
  onConfirmSelectMedia?: (media: IMedia) => void;
  onCancel?: () => void;
  modalId?: string;
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const modalState = useAppSelector((state: RootState) => state.modals.showStandardModal);

  const currentMediaGallery = useAppSelector(getCurrentMediaGallery);

  return (
    <FooterButtons
      cancelText={t("general.cancel")}
      cancelCb={onCancel}
      nextText={t("general.confirm")}
      nextCb={() => {
        if (onConfirmSelectMedia && currentMediaGallery) {
          console.log("Actions.tsx in onConfirmSelectMedia");
          onConfirmSelectMedia(currentMediaGallery);
        }
        if (modalState) {
          console.log("Actions.tsx in ifModalState");
          dispatch(closeStandardModal(modalId ?? ""));
        } else {
          navigate(-1);
        }
      }}
      areTheModalGalleryButtons
    />
  );
};
